'use client';
import React from 'react';
import DraftDocument from './DraftDocument';
import HomeMedia from './HomeMedia';

const Event = (props) => {
  return (
    <div className="flex flex-wrap w-full justify-between mt-5 space-y-5 lg:space-y-0">
      <DraftDocument {...props} />
      <HomeMedia {...props} />
    </div>
  );
};

export default Event;
